import { useEffect, useCallback, useRef } from 'react';
import { Properties } from '../Properties';


const useInactivityTimeout = (onInactive: () => void) => {
  const timeoutRef = useRef<NodeJS.Timeout>();
  const timeoutMinutes = Properties.sessionTimeoutMinutes as number || 10;

  const resetTimeout = useCallback(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    // Convert minutes to milliseconds
    timeoutRef.current = setTimeout(onInactive, timeoutMinutes * 60 * 1000);
  }, [onInactive, timeoutMinutes]);

  const setupEventListeners = useCallback(() => {
    const events = ['mousedown', 'keydown', 'scroll', 'touchstart'];
    events.forEach(event => {
      window.addEventListener(event, resetTimeout);
    });

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      events.forEach(event => {
        window.removeEventListener(event, resetTimeout);
      });
    };
  }, [resetTimeout]);

  useEffect(() => {
    const cleanup = setupEventListeners();
    resetTimeout(); // Start the initial timeout

    return () => {
      cleanup();
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [setupEventListeners, resetTimeout]);
};

export default useInactivityTimeout;